import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { Confirm } from "../../components/confirm";
import { deleteRole } from "../../services/role";
import { useLocale } from "../../stores/locale";
import { navigateBack } from "../../utils/navigate-back";

export function RoleDelete() {
  const navigate = useNavigate();
  const { get: getLocale } = useLocale();
  const queryClient = useQueryClient();
  const { id } = useParams();

  if (!id) {
    throw new Error("Role ID is required");
  }

  const [loading, setLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const closeModal = () => {
    navigateBack(navigate, "/admin/role");
  };

  return (
    <Confirm
      header={
        hasError
          ? getLocale("role.deleteError")
          : getLocale("role.confirmDelete")
      }
      loading={loading}
      onClose={closeModal}
      onConfirm={() => {
        void (async () => {
          setLoading(true);
          try {
            await deleteRole(id);
            await queryClient.invalidateQueries({ queryKey: ["roles"] });
            closeModal();
          } catch {
            setHasError(true);
          } finally {
            setLoading(false);
          }
        })();
      }}
    />
  );
}
